import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AppLocation } from './location.model';
import { environment } from '../../../environments/environment';

export interface NewsSearchFilter {
  categoryId?: number | null;
  year?: number | null;
  publishDate?: string | null;
  newsPosition?: string | null;
  status?: string | null;
  locationId?: number | null;
  title?: string | null;
  langCode?: string | null;
  page?: number | null;
  limit?: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  private apiUrl = environment.apiBaseUrl + '/api/';

  constructor(private http: HttpClient) { }

  // GET roles
  getAllNews(langCode: string): Observable<any> {
    if(langCode === ""){
      return this.http.get(`${this.apiUrl}news`);
    }
    else{
      return this.http.get(`${this.apiUrl}news/?lang=${langCode}`);
    }
  }

  getNewsSearch(filter: NewsSearchFilter): Observable<any> {
    let params = new HttpParams();

    Object.entries(filter).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    });

    return this.http.get(`${this.apiUrl}news-search`, { params });
  }

  getAllNewsCategory(){
    return this.http.get(`${this.apiUrl}categorygetall`);
  }

  getNewsById(id: number,langCode: string): Observable<any> {
    if(langCode === ""){
      return this.http.get(`${this.apiUrl}news/${id}`);
    }
    else {
      return this.http.get(`${this.apiUrl}news/${id}?lang=${langCode}`);
    }
  }

  create(request: any): Observable<any> {
    const formData = new FormData();

    if (request.image) {
      formData.append('Image', request.image);
    }

    if (request.pdf) {
      formData.append('Pdf', request.pdf);
    }

    (request.images || []).forEach((image: File) => {
      formData.append('Images', image);
    });

    formData.append('Data', JSON.stringify(request.data));

    return this.http.post(`${this.apiUrl}news`, formData);
  }

  update(id: number,request: any): Observable<any> {

    const formData = new FormData();

    if (request.image) {
      formData.append('Image', request.image);
    }

    if (request.pdf) {
      formData.append('Pdf', request.pdf);
    }

    (request.images || []).forEach((image: File) => {
      formData.append('Images', image);
    });

    formData.append('Data', JSON.stringify(request.data));

    return this.http.put(`${this.apiUrl}news/${id}`, formData);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}news/${id}`);
  }


  //Create location
  getLocations(): Observable<AppLocation[]> {
    return this.http.get<{ status: string, message: string, data: AppLocation[] }>(`${this.apiUrl}Location`)
      .pipe(
        map(response => response.data)
      );
  }
}
